import { TiersAccessible } from "@glamcorner/gc-types/lib/subscription";
import React from "react";


export type CatalogueLinkProps = {
  tiersAccessible: TiersAccessible;
};

export const CatalogueLink: React.FC<CatalogueLinkProps> = ({ tiersAccessible, children }) => {
  const url = `${
    window?.top?.origin
  }/clothing#collectionDesignation=subscription&sorting=featured&subAvailabilityFilter=any&tiers=${tiersAccessible.join(",")}`;

  return (
    <a className="choosePlan-plan__view-collection" href={url} target="_blank">
      {children}
    </a>
  );
};
